let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("06dxH")).then(() => parcelRequire('9jOdE'));